'use client';
import React from 'react';
import Image from 'next/image';
import { Clock, Target, Layers, Printer, Award, Zap } from 'lucide-react';

const AboutIntro = () => {
  const trustMetrics = [
    { title: '25+ Years', desc: 'Manufacturing Experience', icon: Clock },
    { title: '500+ Brands', desc: 'Served Across India', icon: Target },
    { title: '10+ Segments', desc: 'Industry Verticals', icon: Layers },
    { title: 'Advanced Flexo', desc: 'Multi Color Printing', icon: Printer },
    { title: 'ISO & GMP', desc: 'Certified Facility', icon: Award },
    { title: 'Fast Dispatch', desc: 'Production & Support', icon: Zap }
  ];

  return (
    <section className="w-full bg-white py-16 md:py-24">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="flex flex-col gap-12">
          {/* Hero Header Block */}
          <div className="flex flex-col items-center text-center gap-6">
            <h1 className="text-[36px] md:text-[52px] font-extrabold text-[#0F172A] leading-tight max-w-[950px]">
              India’s Trusted Custom Label Manufacturing Company
            </h1>
            <p className="max-w-[880px] text-lg md:text-xl text-[#334155] font-semibold leading-relaxed">
              Royal Prime Labels manufactures high performance labels for FMCG, Pharma, Cosmetics, Food, Beverage, Industrial and Retail packaging brands across India.
            </p>
            <p className="max-w-[800px] text-base md:text-lg text-[#64748B] leading-relaxed">
              From roll form labels to security labels and premium finishing, we help brands improve shelf visibility with reliable manufacturing standards and scalable production support.
            </p>
          </div>

          {/* Hero Image Card */}
          <div className="relative w-full h-[300px] md:h-[500px] rounded-3xl overflow-hidden shadow-lg border border-slate-200/50">
            <Image
              src="/images/warehouse-labels.jpg"
              alt="Royal Prime Labels Warehouse — rolls of printed labels stored on industrial shelving"
              fill
              className="object-cover"
              sizes="(min-width: 1280px) 1280px, 100vw"
              priority
            />
          </div>

          {/* New Trust Strip Section */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 pt-10 mt-6 border-t border-slate-100">
            {trustMetrics.map((metric, idx) => (
              <div 
                key={idx} 
                className="flex flex-col items-center text-center p-6 bg-[#F8FAFC] border border-slate-200/60 rounded-2xl shadow-[0_2px_8px_rgba(0,0,0,0.01)] hover:shadow-[0_8px_20px_rgba(0,0,0,0.04)] transition-all duration-300 group"
              >
                <div className="mb-4 text-[#C9A84C] group-hover:scale-110 transition-transform duration-300">
                  <metric.icon className="h-6 w-6" />
                </div>
                <h3 className="text-slate-900 font-bold text-[16px] leading-tight">
                  {metric.title}
                </h3>
                <p className="mt-1.5 text-slate-500 text-[12px] font-semibold tracking-wider uppercase leading-snug">
                  {metric.desc}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutIntro;

